module.exports = "<main id=\"contents\" class=\"container\">\n  <div id=\"container-wrapper\">\n    <div class=\"contents-wrapper container\">\n      <input id=\"input-signin\" type=\"text\" value=\"\" #pw />\n    </div>\n    <div class=\"contents-wrapper container\">\n      <button type=\"submit\" (click)=\"onSubmit(pw.value)\">Sign-In</button>\n    </div>\n  </div>\n</main>"


//////////////////
// WEBPACK FOOTER
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/pages/sign-in/sign-in.component.html
// module id = ../../../../../src/app/pages/sign-in/sign-in.component.html
// module chunks = main